// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.center-text[data-v-dcc721a6] {\n  text-align: center;\n}\n.box_size[data-v-dcc721a6] {\n  width: 60mm;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1.2rem;\n}\n", ""]);
// Exports
module.exports = exports;
